/**
 * TanStack Query hooks for `fraud-spike-alerts`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fraudSpikeAlertsQueryKeys,
	type CreateFraudSpikeAlertsBody,
	type ListFraudSpikeAlertsResponse,
	type FraudSpikeAlertsRow,
} from "./api";

export function useFraudSpikeAlertsList(): UseQueryResult<ListFraudSpikeAlertsResponse, Error> {
	return useQuery({
		queryKey: fraudSpikeAlertsQueryKeys.list(),
		queryFn: list,
	});
}

export function useFraudSpikeAlertsCreate(): UseMutationResult<FraudSpikeAlertsRow, Error, CreateFraudSpikeAlertsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudSpikeAlertsQueryKeys.all });
		},
	});
}

export function useFraudSpikeAlertsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fraudSpikeAlertsQueryKeys.all });
		},
	});
}
